import { useMutation } from 'react-query';
import { useApiDelete, useApiPost, useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

export type BCNListResponse = {
  ResolutionType?: string;
  bcn: string;
  bcnCameOnDeal?: boolean;
  hasBCNOnBid: boolean;
  isDefaultBcn?: boolean;
  isResolvedOnException?: boolean;
  resellerAuthorizationNumber: string;
  resellerName: string;
  resolutionType?: string;
};

export type GetBcnListRequest = {
  bcn_linking_level: string;
  customerset_Id: string;
  deal_Id: string;
  importreferenceid?: string | number;
  reseller_authorization: string;
  vendor_program_id?: string | number;
};

export type DeleteBCNRequest = {
  BCN: string;
  BcnCameOnDeal: boolean;
  bcn_linking_level: string;
  customerset_Id: string;
  deal_Id: string;
  importreferenceid: string;
  reseller_authorization: string;
};
export type PostBCNRequest = {
  BCN: string;
  customerset_Id: string;
  deal_Id: string;
  editor: string;
  importreferenceid: string;
  source: string;
};

export function useGetBCNList(params: GetBcnListRequest, enabled: boolean) {
  const buildvars = useBuildVars();
  return useApiQuery<BCNListResponse[]>(
    '/system.webapi.gds/api/v1/GdsCoreApiDeals/BCNList',
    params,
    { enabled },
    undefined,
    { host: buildvars.VP_API_BASE }
  );
}

export function useDeleteBCN() {
  const buildVars = useBuildVars();
  const apiDelete = useApiDelete(buildVars.VP_API_BASE);
  return useMutation((params: DeleteBCNRequest) => {
    return apiDelete(
      '/system.webapi.gds/api/v1/GdsCoreApiDeals/DeleteBCN',
      undefined,
      params
    );
  });
}
export function useAddBCN() {
  const buildVars = useBuildVars();
  const apiPost = useApiPost<PostBCNRequest>({
    host: buildVars.VP_API_BASE,
  });
  return useMutation((request: PostBCNRequest) =>
    apiPost('/system.webapi.gds/api/v1/GdsCoreApiDeals/AddBCN', {}, request)
  );
}
